/**
 * @fileoverview GET handler for the "/oauth/validate_scopes" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { oauthValidateScopes } from "./constants";
import type { OAuthValidateScopesResult, OAuthValidateScopesResultErrors } from "./types";
import { isOAuthValidateScopesResult } from "./validators";

export const getOAuthValidateScopes = reactQueryFetcherAdapter(
  oauthValidateScopes,
  createGetFetcherFunctionWithShadowError<OAuthValidateScopesResultErrors>()(
    (signal: AbortSignal, scopes: string[]): Promise<OAuthValidateScopesResult> => {
      return fetch("/oauth/validate_scopes", "GET", { scopes }, { signal }, { propagateFetchRequestError: false });
    }
  ),
  isOAuthValidateScopesResult
);
